import { memo } from 'react';
import { Link } from 'react-router-dom';
import { Button as MuiButton } from '@mui/material';
import { openSignupModal } from '@client/components/Main/Signup';
import { HomeSection } from '@client/components/common/HomeSection';
import { useSelector } from '@client/hooks/redux.hooks';
import { getSessionUserState } from '@client/selectors/helpers/login';
import { DocumentTitle } from '@client/components/common/DocumentTitle';
import { useIsMobile } from '@client/hooks/dom.hooks';
import { PayoutInfo } from '../Home/common/PayoutInfo';
import { Header } from '../Home/common/Header';
import { Section } from './Section';
import { ConsultationCTA } from './ConsultationCTA';
import ForArtistsAndHosts1 from './images/forartistsandhosts-1.jpg';
import ForArtistsAndHosts2 from './images/forartistsandhosts-2.jpg';
import ForArtistsAndHosts3 from './images/forartistsandhosts-3.jpg';
import ForArtistsAndHosts4 from './images/forartistsandhosts-4.jpg';
import ForArtistsAndHosts5 from './images/forartistsandhosts-5.jpg';
import ForArtistsAndHosts6 from './images/forartistsandhosts-6.jpg';
import ForArtistsAndHosts7 from './images/forartistsandhosts-7.jpg';

export const ForArtistsAndHosts = memo(() => {
  const isMobile = useIsMobile();
  const userState = useSelector(getSessionUserState);

  return (
    <>
      <DocumentTitle title="For Artists and Hosts" />

      {!isMobile && <Header maxWidth="lg" />}

      <Section
        title="Any space is a venue."
        titleVariant="h4"
        description="Whether you’re looking to perform or host, Side Door provides the tools to curate live art in your community."
        imgSrc={ForArtistsAndHosts1}
        button={!userState ? (
          <MuiButton
            id="sda-for-artists-and-hosts-sign-up-button"
            onClick={openSignupModal as any}
            variant="contained"
            color="secondary_dark"
            size="large"
            className="main-signup-button"
          >
            Sign Up
          </MuiButton>
        ) : (
          <MuiButton
            id="sda-for-artists-and-hosts-connect-button"
            variant="contained"
            color="secondary_dark"
            size="large"
            component={Link}
            to="/connect"
          >
            Connect
          </MuiButton>
        )}
      />

      <HomeSection>
        <PayoutInfo />
      </HomeSection>

      <Section
        title="Join"
        description="Whether you’re an artist or a host, profiles with thoughtful descriptions, high-quality photos, and links to your media always get more interest."
        imgSrc={ForArtistsAndHosts2}
      />

      <Section
        title="Connect"
        description="Create or respond to Show Calls to start collaborating with artists and hosts around the world."
        imgSrc={ForArtistsAndHosts3}
      />

      <Section
        title="Book"
        description="Book a single show or a whole tour with just a few clicks. You can set flexible ticket prices, split the show’s revenue, and manage performance royalties."
        imgSrc={ForArtistsAndHosts4}
      />

      <Section
        title="Promote"
        description="Use affiliate links to track sales from promoters or social media. Tag us to be featured on our social channels!"
        imgSrc={ForArtistsAndHosts5}
      />

      <Section
        title="Showtime"
        description="Use the Audience Manager and ticket scanner to check in the audience, and enjoy the magic of an intimate show experience."
        imgSrc={ForArtistsAndHosts6}
      />

      <Section
        title="Payout"
        description="Get paid directly to your bank or Paypal account within 72 hours of show completion, and know where every penny goes with your settlement."
        imgSrc={ForArtistsAndHosts7}
      />

      <ConsultationCTA />
    </>
  );
});

export default ForArtistsAndHosts;
